/* import __COLOCATED_TEMPLATE__ from './facebook.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { tracked } from '@glimmer/tracking';
import {
  race,
  restartableTask,
  waitForProperty,
  timeout,
} from 'ember-concurrency';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-facebook-player';

/* Play action will be available almost immediately (unless video is unavailable) */
const PLAY_UNAVAILABLE_GIVEUP_DURATION_MS = 300;

/**
 * A component which renders a calculate potential freelancer earnings button.
 */
 class FacebookPlayer extends Component {
  @tracked embedReady = false;
  @tracked playerInstance = null;
  @tracked fbSubscription = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get playerAspectRatioStyle() {
    const { width, height } = this.args;
    if (!width || !height) {
      return '--player-aspect-ratio: 16 / 9;';
    }

    return htmlSafe(`--player-aspect-ratio: ${width} / ${height};`);
  }

  @action
  removeSubscriptions() {
    // clean up
    if (this.fbSubscription) {
      FB.Event.unsubscribe('xfbml.ready', this.xfbmlReadyHandler);
      this.fbSubscription = false;
    }
  }

  @action
  xfbmlReadyHandler(msg) {
    const { videoId } = this.args;

    if (msg.type === 'video' && msg.id === `fb-video-player-${videoId}`) {
      this.playerInstance = msg.instance;
      this.embedReady = true;

      if (this.args.autoplay) {
        this.playerInstance.play();
      }
    } else {
      this.embedReady = true;
    }
  }

  @restartableTask
  *loadPlayer() {
    this.playerInstance = null;
    this.embedReady = false;

    yield waitForProperty(this, 'args.loadSDKTask.lastSuccessful');

    // clear subscription tied to old video
    this.removeSubscriptions();

    // re-parse for facebook video
    FB.XFBML.parse();

    // subscribe to player events
    FB.Event.subscribe('xfbml.ready', this.xfbmlReadyHandler);
    this.fbSubscription = true;

    // keep task running until player ready event
    yield race([
      waitForProperty(this, 'embedReady'),
      timeout(PLAY_UNAVAILABLE_GIVEUP_DURATION_MS),
    ]);
  }
}

export default FacebookPlayer;
